import React from 'react';
import './ProfileCardStyle.css';
function ProfileCard({ img, number, text, className }) {
    return (
        <div className={`CardContactWrapper ${className}`}>
            <span className='Adicontoolsicons flex-center'>
                <img src={img} alt="" />
            </span>
            <div className="contentareacontact">
                <span>{number}</span>
                <p className='mt-5 text2'>{text}</p>
            </div>
        </div>
    )
}

export default ProfileCard